<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - AGE GROUP</h2>
       <p>Age group details</p>
      <!-- <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
        <div *ngFor="let agegroup of arrayval">
       <div class="row">

        <div class="col-lg-4 col-md-4 col-sm-12">
      <p><span class="blue">Age Group:&nbsp;</span><span id="agegroupname" >{{agegroup.tnag_name}}</span></p>
        </div>
       <div class="col-lg-4 col-md-4 col-sm-12">
       <p><span class="blue">Lower Limit (Days):&nbsp;</span><span id="lowerlimit" >{{agegroup.lowerlimit}}</span></p>
       </div>
       <div class="col-lg-4 col-md-4 col-sm-12">
        <p><span class="blue">Upper Limit (Days):&nbsp;</span><span id="upperlimit" >{{agegroup.upperlimit}}</span></p>
        </div>
        
       </div>
      </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='speciesmanagement()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       <br>
       <!--<button type="submit" class="btn btn-fill btn-default">
        Cancel <div class="ripple-container"></div>
       </button>-->
       </div>
       </div>
     </div>
   </div>
 </div>
